import { BrainAvatar } from "./BrainAvatar";
import { Message, Brain } from "@/lib/types";

interface ChatMessageProps {
  message: Message;
  brain?: Brain;
}

export const ChatMessage = ({ message, brain }: ChatMessageProps) => {
  // Debug logging
  console.log('ChatMessage render:', { message, brain, content: message.content });

  const text = (message.content ?? "").trim();
  if (!text) return null; // Don't render empty messages

  if (message.sender === "user") {
    return (
      <div className="flex justify-end">
        <div className="max-w-[80%] bg-chat-user rounded-2xl px-4 py-3">
          <p className="text-foreground">{text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3">
      {brain && (
        <BrainAvatar 
          color={brain.color} 
          status={brain.status}
          size="sm"
        />
      )}
      <div className="flex-1">
        {brain && (
          <div className="mb-1">
            <span className="text-sm text-foreground font-medium">{brain.name}</span>
            <span className="text-xs text-muted-foreground ml-2">{brain.role}</span>
          </div>
        )}
        <div className="max-w-[90%] bg-chat-assistant rounded-2xl px-4 py-3 min-h-[44px]">
          <p className="text-foreground whitespace-pre-wrap">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
};